import { Validators } from '@angular/forms';
export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}

/**
 * @description
 * Validateurs + required fields des BPForms
 */

/**
 * @description
 * Validateurs + required fields des BPForms
 */
export const BPVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(false, [])],
      ['idCreateur', new FormInfo(false, [])],
      ['dModification', new FormInfo(false, [])],
      ['idModifieur', new FormInfo(false, [])],
      ['dDesactivation', new FormInfo(false, [])],
      ['idDesativateur', new FormInfo(false, [])],
      ['idSociete', new FormInfo(false, [])],
      ['societe', new FormInfo(false, [])],

      ['code', new FormInfo(true, [])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],

      ['codeSiteLivraison', new FormInfo(false, [])],
      ['libelleSiteLivraison', new FormInfo(false, [])],

      ['codeSite', new FormInfo(true, [Validators.required])],
      ['libelleSite', new FormInfo(true, [Validators.required])],

      ['codeCa1', new FormInfo(false, [Validators.required])],
      ['libelleCa1', new FormInfo(false, [Validators.required])],

      ['codeModeRegl', new FormInfo(true, [Validators.required])],
      ['libelleModeRegl', new FormInfo(true, [Validators.required])],

      ['codeCondRegl', new FormInfo(true, [Validators.required])],
      ['libelleCondRegl', new FormInfo(true, [Validators.required])],

      ['codeFourn', new FormInfo(false, [Validators.required])],
      ['libelleFourn', new FormInfo(false, [Validators.required])],

      ['status', new FormInfo(true, [])],
      ['motif', new FormInfo(false, [Validators.maxLength(50)])],
      ['commentaires', new FormInfo(false, [Validators.maxLength(255)])],

      ['refFourn', new FormInfo(false, [Validators.maxLength(30)])],
      ['urlFacture', new FormInfo(false, [])],
      ['numFacture', new FormInfo(false, [Validators.required])],
      ['dFacture', new FormInfo(false, [Validators.required])],
      ['montantFacture', new FormInfo(false, [Validators.required])],

      ['ruidEsker', new FormInfo(true, [])],
      
      ['dBp', new FormInfo(true, [Validators.required])],
      ['dRegl', new FormInfo(true, [])],
      ['dAnnule', new FormInfo(false, [])],
      ['tva', new FormInfo(false, [])],
      ['ht', new FormInfo(false, [])],
      ['ttc', new FormInfo(false, [])],

      ['fValide', new FormInfo(false, [])],
      ['bFacture', new FormInfo(false, [])],
      ['bAnnule', new FormInfo(false, [])],
      ['retour', new FormInfo(false, [])],
      ['blocque', new FormInfo(false, [])],
      ['trigrammeCreateur', new FormInfo(false, [])],
      ['nomCompletCreateur', new FormInfo(false, [])]
      ]),
    VALIDATE: new Map<string, FormInfo>([
      ['id', new FormInfo(true, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],
      ['idSociete', new FormInfo(true, [])],
      ['societe', new FormInfo(true, [])],

      ['code', new FormInfo(true, [])],
      ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(30)])],

      ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
      ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

      ['codeSite', new FormInfo(true, [Validators.required])],
      ['libelleSite', new FormInfo(true, [Validators.required])],

      ['codeCa1', new FormInfo(true, [Validators.required])],
      ['libelleCa1', new FormInfo(true, [Validators.required])],

      ['codeModeRegl', new FormInfo(false, [Validators.required])],
      ['libelleModeRegl', new FormInfo(false, [Validators.required])],

      ['codeCondRegl', new FormInfo(false, [Validators.required])],
      ['libelleCondRegl', new FormInfo(false, [Validators.required])],

      ['codeFourn', new FormInfo(false, [Validators.required])],
      ['libelleFourn', new FormInfo(false, [Validators.required])],

      ['status', new FormInfo(true, [])],
      ['motif', new FormInfo(true, [Validators.maxLength(50)])],
      ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],

      ['refFourn', new FormInfo(true, [Validators.maxLength(30)])],
      ['numFacture', new FormInfo(true, [Validators.required])],
      ['urlFacture', new FormInfo(false, [])],

      ['montantFacture', new FormInfo(true, [])],
      ['ruidEsker', new FormInfo(true, [])],
      ['dBp', new FormInfo(true, [])],
      ['dFacture', new FormInfo(true, [])],
      ['dRegl', new FormInfo(true, [])],
      ['dAnnule', new FormInfo(true, [])],
      ['tva', new FormInfo(true, [])],
      ['ht', new FormInfo(true, [])],
      ['ttc', new FormInfo(true, [])],

      ['fValide', new FormInfo(true, [])],
      ['bFacture', new FormInfo(true, [])],
      ['bAnnule', new FormInfo(true, [])],
      ['retour', new FormInfo(true, [])],
      ['blocque', new FormInfo(true, [])],
      ['trigrammeCreateur', new FormInfo(true, [])],
      ['nomCompletCreateur', new FormInfo(true, [])]
      ]),
      FACTURE: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['idDesativateur', new FormInfo(true, [])],
        ['idSociete', new FormInfo(true, [])],
        ['societe', new FormInfo(true, [])],

        ['code', new FormInfo(true, [])],
        ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(30)])],

        ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
        ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

        ['codeSite', new FormInfo(true, [Validators.required])],
        ['libelleSite', new FormInfo(true, [Validators.required])],

        ['codeCa1', new FormInfo(true, [Validators.required])],
        ['libelleCa1', new FormInfo(true, [Validators.required])],

        ['codeModeRegl', new FormInfo(false, [Validators.required])],
        ['libelleModeRegl', new FormInfo(false, [Validators.required])],

        ['codeCondRegl', new FormInfo(false, [Validators.required])],
        ['libelleCondRegl', new FormInfo(false, [Validators.required])],

        ['codeFourn', new FormInfo(false, [Validators.required])],
        ['libelleFourn', new FormInfo(false, [Validators.required])],

        ['status', new FormInfo(true, [])],
        ['motif', new FormInfo(true, [Validators.maxLength(50)])],
        ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],

        ['refFourn', new FormInfo(true, [Validators.maxLength(30)])],
        ['numFacture', new FormInfo(false, [Validators.required])],
        ['montantFacture', new FormInfo(true, [])],
        ['urlFacture', new FormInfo(false, [])],
        ['ruidEsker', new FormInfo(true, [])],
        ['dBp', new FormInfo(true, [])],
        ['dFacture', new FormInfo(false, [])],
        ['dRegl', new FormInfo(true, [])],
        ['dAnnule', new FormInfo(true, [])],
        ['tva', new FormInfo(true, [])],
        ['ht', new FormInfo(true, [])],
        ['ttc', new FormInfo(true, [])],

        ['fValide', new FormInfo(true, [])],
        ['bFacture', new FormInfo(true, [])],
        ['bAnnule', new FormInfo(true, [])],
        ['retour', new FormInfo(true, [])],
        ['blocque', new FormInfo(true, [])],
        ['trigrammeCreateur', new FormInfo(true, [])],
        ['nomCompletCreateur', new FormInfo(true, [])]
        ]),
      VISUALISE: new Map<string, FormInfo>([
        ['id', new FormInfo(true, [])],
        ['dCreation', new FormInfo(true, [])],
        ['idCreateur', new FormInfo(true, [])],
        ['dModification', new FormInfo(true, [])],
        ['idModifieur', new FormInfo(true, [])],
        ['dDesactivation', new FormInfo(true, [])],
        ['idDesativateur', new FormInfo(true, [])],
        ['idSociete', new FormInfo(true, [])],
        ['societe', new FormInfo(true, [])],

        ['code', new FormInfo(true, [])],
        ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(30)])],

        ['codeSiteLivraison', new FormInfo(true, [Validators.required])],
        ['libelleSiteLivraison', new FormInfo(true, [Validators.required])],

        ['codeSite', new FormInfo(true, [Validators.required])],
        ['libelleSite', new FormInfo(true, [Validators.required])],

        ['codeCa1', new FormInfo(true, [Validators.required])],
        ['libelleCa1', new FormInfo(true, [Validators.required])],

        ['codeModeRegl', new FormInfo(true, [Validators.required])],
        ['libelleModeRegl', new FormInfo(true, [Validators.required])],

        ['codeCondRegl', new FormInfo(true, [Validators.required])],
        ['libelleCondRegl', new FormInfo(true, [Validators.required])],

        ['codeFourn', new FormInfo(true, [Validators.required])],
        ['libelleFourn', new FormInfo(true, [Validators.required])],

        ['status', new FormInfo(true, [])],
        ['motif', new FormInfo(true, [Validators.maxLength(50)])],
        ['commentaires', new FormInfo(true, [Validators.maxLength(255)])],

        ['refFourn', new FormInfo(true, [Validators.maxLength(30)])],
        ['numFacture', new FormInfo(true, [Validators.required])],
        ['urlFacture', new FormInfo(false, [])],
        ['montantFacture', new FormInfo(true, [])],
        ['ruidEsker', new FormInfo(true, [])],
        ['dBp', new FormInfo(true, [])],
        ['dFacture', new FormInfo(true, [])],
        ['dRegl', new FormInfo(true, [])],
        ['dAnnule', new FormInfo(true, [])],
        ['tva', new FormInfo(true, [])],
        ['ht', new FormInfo(true, [])],
        ['ttc', new FormInfo(true, [])],

        ['fValide', new FormInfo(true, [])],
        ['bFacture', new FormInfo(true, [])],
        ['bAnnule', new FormInfo(true, [])],
        ['retour', new FormInfo(true, [])],
        ['blocque', new FormInfo(true, [])],
        ['trigrammeCreateur', new FormInfo(true, [])],
        ['nomCompletCreateur', new FormInfo(true, [])]
        ]),
  };

  /**
   * @description
   * Validateurs + required fields des BPLinesForms
   */
export const BPLINEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['idBp', new FormInfo(false, [])],
      ['idBcLigne', new FormInfo(false, [])],
      ['bcLigne', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],

      ['code', new FormInfo(false, [])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(255)])],
      ['idSociete', new FormInfo(false, [])],
      ['societe', new FormInfo(false, [])],

      ['codeArticle', new FormInfo(true, [])],
      ['libelleArticle', new FormInfo(true, [])],

      ['codeTva', new FormInfo(false, [Validators.required])],
      ['libelleTva', new FormInfo(false, [])],
      ['tauxTva', new FormInfo(false, [Validators.required])],

      ['codeCa1', new FormInfo(false, [Validators.required])],
      ['libelleCa1', new FormInfo(false, [Validators.required])],
      ['codeCa2', new FormInfo(false, [])],
      ['libelleCa2', new FormInfo(false, [])],

      ['codeNa', new FormInfo(false, [Validators.required])],
      ['libelleNa', new FormInfo(false, [Validators.required, Validators.maxLength(50)])],
      ['codeCgCharge', new FormInfo(true, [Validators.required])],
      ['libelleCgCharge', new FormInfo(true, [Validators.required, Validators.maxLength(30)])],

      ['bAnnule', new FormInfo(false, [])],
      ['dAnnule', new FormInfo(true, [])],
      ['dDprovis', new FormInfo(true, [])], 

      ['position', new FormInfo(false, [])],
      ['qte', new FormInfo(false, [Validators.min(0)])],
      ['pu', new FormInfo(false, [])],
      ['ht', new FormInfo(true, [])],
      ['ttc', new FormInfo(true, [])],

      ['codeComp', new FormInfo(false, [])],
      ['libelleComp', new FormInfo(false, [])],
      ['vehicule', new FormInfo(false, [])],
      ['chantier', new FormInfo(false, [])],
      ['bFacture', new FormInfo(true, [])]

    ]),
    VALIDATE: new Map<string, FormInfo>([
      ['id', new FormInfo(true, [])],
      ['idBp', new FormInfo(true, [])],
      ['idBcLigne', new FormInfo(true, [])],
      ['bcLigne', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],

      ['code', new FormInfo(true, [])],
      ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
      ['idSociete', new FormInfo(true, [])],
      ['societe', new FormInfo(true, [])],

      ['codeArticle', new FormInfo(true, [Validators.required])],
      ['libelleArticle', new FormInfo(true, [Validators.required])],

      ['codeTva', new FormInfo(true, [Validators.required])],
      ['libelleTva', new FormInfo(true, [])],
      ['tauxTva', new FormInfo(true, [Validators.required])],

      ['codeCa1', new FormInfo(true, [Validators.required])],
      ['libelleCa1', new FormInfo(true, [ Validators.required])],

      ['codeCa2', new FormInfo(true, [Validators.required])],
      ['libelleCa2', new FormInfo(true, [Validators.required])],

      ['codeNa', new FormInfo(true, [Validators.required])],
      ['libelleNa', new FormInfo(true, [Validators.required])],

      ['codeCgCharge', new FormInfo(true, [Validators.required])],
      ['libelleCgCharge', new FormInfo(true, [Validators.required])],

      ['chantier', new FormInfo(true, [])],

      ['codeComp', new FormInfo(true, [])],
      ['libelleComp', new FormInfo(true, [])],

      ['vehicule', new FormInfo(true, [Validators.required])],

      ['dAnnule', new FormInfo(true, [])],
      ['dDprovis', new FormInfo(true, [])], 

      ['qte', new FormInfo(true, [Validators.min(0)])],
      ['pu', new FormInfo(true, [])],
      ['ht', new FormInfo(true, [])],
      ['ttc', new FormInfo(true, [])],

      ['bFacture', new FormInfo(true, [])],
      ['bAnnule', new FormInfo(true, [])],

        ]),
    FACTURE: new Map<string, FormInfo>([
      ['id', new FormInfo(true, [])],
      ['idBp', new FormInfo(true, [])],
      ['idBcLigne', new FormInfo(true, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],

      ['code', new FormInfo(true, [])],
      ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
      ['idSociete', new FormInfo(true, [])],
      ['societe', new FormInfo(true, [])],

      ['codeArticle', new FormInfo(true, [Validators.required])],
      ['libelleArticle', new FormInfo(true, [Validators.required])],

      ['codeTva', new FormInfo(false, [Validators.required])],
      ['libelleTva', new FormInfo(false, [])],
      ['tauxTva', new FormInfo(false, [Validators.required])],

      ['codeCa1', new FormInfo(false, [Validators.required])],
      ['libelleCa1', new FormInfo(false, [Validators.required])],

      ['codeCa2', new FormInfo(false, [Validators.required])],
      ['libelleCa2', new FormInfo(false, [Validators.required])],

      ['codeNa', new FormInfo(false, [Validators.required])],
      ['libelleNa', new FormInfo(false, [Validators.required])],

      ['codeCgCharge', new FormInfo(false, [Validators.required])],
      ['libelleCgCharge', new FormInfo(false, [Validators.required])],

      ['chantier', new FormInfo(true, [])],
      ['position', new FormInfo(true, [])],

      ['codeComp', new FormInfo(false, [])],
      ['libelleComp', new FormInfo(false, [])],

      ['vehicule', new FormInfo(true, [Validators.required])],

      ['dAnnule', new FormInfo(true, [])],
      ['dDprovis', new FormInfo(true, [])], 

      ['qte', new FormInfo(true, [Validators.min(0)])],
      ['pu', new FormInfo(true, [])],
      ['ht', new FormInfo(true, [])],
      ['ttc', new FormInfo(true, [])],

      ['bFacture', new FormInfo(true, [])],
      ['bAnnule', new FormInfo(true, [])],
      ['bcLigne', new FormInfo(false, [])],

    ]),
    VISUALISE: new Map<string, FormInfo>([
      ['id', new FormInfo(true, [])],
      ['idBp', new FormInfo(true, [])],
      ['idBcLigne', new FormInfo(true, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['idDesativateur', new FormInfo(true, [])],

      ['code', new FormInfo(true, [])],
      ['libelle', new FormInfo(true, [Validators.required, Validators.maxLength(255)])],
      ['idSociete', new FormInfo(true, [])],
      ['societe', new FormInfo(true, [])],

      ['codeArticle', new FormInfo(true, [Validators.required])],
      ['libelleArticle', new FormInfo(true, [Validators.required])],

      ['codeTva', new FormInfo(true, [Validators.required])],
      ['libelleTva', new FormInfo(true, [])],
      ['tauxTva', new FormInfo(true, [Validators.required])],

      ['codeCa1', new FormInfo(true, [Validators.required])],
      ['libelleCa1', new FormInfo(true, [Validators.required])],

      ['codeCa2', new FormInfo(true, [Validators.required])],
      ['libelleCa2', new FormInfo(true, [Validators.required])],

      ['codeNa', new FormInfo(true, [Validators.required])],
      ['libelleNa', new FormInfo(true, [Validators.required])],

      ['codeCgCharge', new FormInfo(true, [Validators.required])],
      ['libelleCgCharge', new FormInfo(true, [Validators.required])],
      ['position', new FormInfo(true, [])],

      ['chantier', new FormInfo(true, [])],

      ['codeComp', new FormInfo(true, [])],
      ['libelleComp', new FormInfo(true, [])],

      ['vehicule', new FormInfo(true, [Validators.required])],

      ['dAnnule', new FormInfo(true, [])], 
      ['dDprovis', new FormInfo(true, [])], 

      ['qte', new FormInfo(true, [Validators.required, Validators.min(0)])],
      ['pu', new FormInfo(true, [Validators.required])],
      ['ht', new FormInfo(true, [])],
      ['ttc', new FormInfo(true, [])],

      ['bFacture', new FormInfo(true, [])],
      ['bAnnule', new FormInfo(true, [])],
      ['bcLigne', new FormInfo(true, [])],


    ]),
  };
